import {
    FETCH_ASSOCIATE_TYPES, FETCH_ASSOCIATE_TYPES_SUCCESS, FETCH_ASSOCIATE_TYPES_FAILURE, RESET_ASSOCIATE_TYPES
} from '../actions/associateTypes';

const INITIAL_STATE = {
    associateTypesList: {associateTypes: [], error: null, loading: false}
};

export default function(state = INITIAL_STATE, action) {
    let error;
    switch(action.type) {
        case FETCH_ASSOCIATE_TYPES:// start fetching employments and set loading = true
            return { ...state, associateTypesList: {associateTypes:[], error: null, loading: true} };
        case FETCH_ASSOCIATE_TYPES_SUCCESS:// return list of employments and make loading = false
            return { ...state, associateTypesList: {associateTypes: action.payload, error: null, loading: false} };
        case FETCH_ASSOCIATE_TYPES_FAILURE:// return error and make loading = false
            error = action.payload || {message: action.payload.message};//2nd one is network or server down errors
            return { ...state, associateTypesList: {associateTypes: [], error: error, loading: false} };
        case RESET_ASSOCIATE_TYPES:// reset employmentsList to initial state
            return { ...state, associateTypesList: {associateTypes: [], error: null, loading: false} };
        default:
            return state;
    }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/reducer_associate_types.js
 **/